import { t } from "i18next";
import numeral from "numeral";

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fCurrency(number: InputValue) {
  // const format = number ? numeral(number).format("$0,0.00") : "";
  const format = number ? numeral(number).format("0.00") : "";

  return result(format, ".00");
}

export function fCustomCurrency(number: InputValue, currency: string) {
  // const format = number ? numeral(number).format("$0,0.00") : "";
  const format = number
    ? numeral(number).format("0.00") +
      " " +
      (currency ? currency.toUpperCase() : "")
    : "";

  return result(format, ".00");
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format("0.0%") : "";

  return result(format, ".0");
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format("0.00a") : "";

  return result(format, ".00");
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format("0.0 b") : "";

  return result(format, ".0");
}

function result(format: string, key = ".00") {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, "") : format;
}

export function displayPriceCredit(
  price: number | null,
  currency: string,
  credit: number | string | null,
  separator?: string
): string {
  // ✅ Convert credit safely to a number
  const numericCredit = credit !== null ? Number(credit) : 0;
  const numericPrice = price !== null ? Number(price) : 0;

  const formattedPrice =
    numericPrice > 0 ? fCustomCurrency(numericPrice, currency) : null;
  const formattedCredit =
    numericCredit > 0 ? `${numericCredit.toFixed(2)} ${t("credit")}` : null;
  const delimiter = separator ? separator : "&";

  if (!currency) {
    return "";
  }
  // ✅ Case 1: Both are null or 0 → Display "0 + Currency"
  if (numericPrice === 0 && numericCredit === 0) {
    return `0 ${currency?.toUpperCase()}`;
  }

  // ✅ Case 2: Only price is greater than 0 → Display price
  if (numericPrice > 0 && !formattedCredit) {
    return formattedPrice!;
  }

  // ✅ Case 3: Only credit is greater than 0 → Display credit
  if (numericCredit > 0 && !formattedPrice) {
    return formattedCredit!;
  }

  if (formattedPrice == null && formattedCredit == null) {
    return "-";
  }

  // ✅ Case 4: Both are greater than 0 → Display both
  return `${formattedPrice} ${delimiter} ${formattedCredit}`;
}

// export function displayPriceCredit(
//   price: number,
//   currency: string,
//   credit: number,
//   separator?: string
// ): string {
//   const formattedPrice =
//     price > 0
//       ? fCustomCurrency(price, currency)
//       : fCustomCurrency(price, currency);

//   const formattedCredit =
//     Number(credit) > 0 ? `${Number(credit).toFixed(2)} ${t("credit")}` : "";
//   const delimiter = separator ? separator : "&";
//   if (price > 0 && formattedCredit) {
//     return `${formattedPrice} ${delimiter} ${formattedCredit}`;
//   }

//   return formattedPrice || formattedCredit;
// }
